import { Link as MuiLink } from '@mui/material';
import React from 'react';

/**
 * LocalizedLink works with MUI Link or Button components
 * and automatically adds /en prefix if current language is English
 */
export default function LocalizedLink({ href, onClick, ...props }) {
  const currentLanguage = localStorage.getItem('i18nextLng');
  // Compute localized URL
  let localizedHref = href;
  if (
    currentLanguage === 'en' &&
    href.startsWith('/') &&
    !href.startsWith('/en')
  ) {
    localizedHref = `/en${href}`;
  }
  if (currentLanguage === 'ko') {
    localizedHref = href.replace(/^\/en/, '') || '/';
  }

  // Handle navigation for pure React/CRA project
  const handleClick = (e) => {
    if (onClick) onClick(e);
    if (!props.target || props.target === '_self') {
      e.preventDefault();
      window.location.href = localizedHref;
    }
  };

  return (
    <MuiLink
      {...props}
      href={localizedHref}
      onClick={handleClick}
      underline="none"
      style={{ ...props.style }}
    />
  );
}
